<template>
  <Cover @click="$emit('click')" class="cover-weixin-share">
    <div class="text">
      <div>
        <span>点击右上角 “</span>
        <span class="icon"><i class="fa fa-ellipsis-h" aria-hidden="true"></i></span>
        <span>” </span>
      </div>
      <div>
        <span>{{text}}</span>
      </div>
    </div>
    <div class="img"></div>
  </Cover>
</template>

<script>
import Cover from './Cover.vue'
export default {
  components: { Cover },
  props: {
    text: {
      type: String,
      default: '分享给微信好友、朋友圈等'
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.cover-weixin-share {
  & .text {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;

    height: 20%;
    text-align: center;
    line-height: 2rem;
    color: var(--colorWhite);
    @media (--mediaPc) {
      font-size: var(--textSize1);
    }
    @media (--mediaMobile) {
      font-size: var(--textSize1Mobile);
    }
  }
  & .icon {
    color: var(--color1);
  }
  & .img {
    position: absolute;
    top: 10%;
    height: 20%;
    width: 90%;
    background-repeat: no-repeat;
    background-position: right;
    background-size: contain;
    background-image: url('https://az.cdn.nutsbp.com/007/image/nuts_dartcome/phone/pr/cut_page/pr_phone_gesture_right.png');
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cover/WeixinShareCover.vue